import { useSeo } from "@/hooks/useSeo";
import { lazy, Suspense, useState, useEffect } from "react";
import ProductGrid from "@/components/ProductGrid";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import CraftSection from "@/components/CraftSection";
import StorySection from "@/components/StorySection";
import Footer from "@/components/Footer";
import ProductMarquee from "@/components/ProductMarquee";
import FeatureStrip from "@/components/FeatureStrip";
import GiftSetSection from "@/components/GiftSetSection";

// Lazy load chat widget - not needed on initial page load
const ChatWidget = lazy(() => import("@/components/ChatWidget"));

const Index = () => {
  useSeo('Luxe Lords™ | 10ml Vegan Leather Perfume Atomizers', 'Luxury 10ml refillable perfume atomizers in premium vegan leather. Eight colours, £24.95.', '/');
  const [showAll, setShowAll] = useState(false);
  useEffect(() => { if (window.location.hash === "#gift-sets") { const t = setTimeout(() => document.getElementById("gift-sets")?.scrollIntoView({ behavior: "smooth" }), 600); return () => clearTimeout(t); } }, []);
  return (
    <div className="min-h-screen">
      <Navigation />
      <main>
      <Hero />
      <ProductMarquee expanded={showAll} onToggle={() => { setShowAll(true); setTimeout(() => document.getElementById("collection")?.scrollIntoView({ behavior: "smooth", block: "start" }), 50); }} />
      {showAll && <div className="animate-fade-in"><ProductGrid /></div>}
      <GiftSetSection />
      <FeatureStrip />
      <CraftSection />
      <StorySection />
      </main>
      <Footer />
      <Suspense fallback={null}>
        <ChatWidget />
      </Suspense>
    </div>
  );
};

export default Index;
